import * as ADMIN_ACTION_TYPE from "./actionTypes";
import * as GLOBAL_ACTION_TYPE from "../DraftRegistration/actionTypes";

export const initialState = {
    userInfo: {},
    searchRecords: { tableData: [], paginationDetails: {} },
    warrantyReceivedDate: undefined,
    waiverReceived: false,
    contractorSelection: undefined,
    tempContractorSelection: undefined,
    isSubmittedForm: false,
    warrantyExistStatus: {},
    selectedWarrantyDetails: {},
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADMIN_ACTION_TYPE.FETCH_USER_INFO_SUCCESS: {
            return { ...state, userInfo: { ...action.value } };
        }
        case ADMIN_ACTION_TYPE.FETCH_SEARCH_RECORDS_RESET: {
            return {
                ...state,
                searchRecords: { tableData: [], paginationDetails: {} },
            };
        }
        case ADMIN_ACTION_TYPE.FETCH_SEARCH_RECORDS_SUCCESS: {
            return {
                ...state,
                searchRecords: { tableData: [...action.value], paginationDetails: action.paging },
            };
        }
        case ADMIN_ACTION_TYPE.UPDATE_CONTRACTOR_SELECTION: {
            return { ...state, contractorSelection: action.payload };
        }
        case ADMIN_ACTION_TYPE.FETCH_CONTRACTOR_INFO_SUCCESS: {
            return { ...state, tempContractorSelection: action.payload };
        }
        case ADMIN_ACTION_TYPE.FETCH_WARRANTY_DETAILS_SUCCESS: {
            return { ...state, selectedWarrantyDetails: { ...action.payload } };
        }
        case ADMIN_ACTION_TYPE.UPDATE_RECEIVED_DATE: {
            return { ...state, warrantyReceivedDate: action.payload };
        }
        case ADMIN_ACTION_TYPE.UPDATE_WAIVER_RECEIVED: {
            return { ...state, waiverReceived: action.payload };
        }
        case ADMIN_ACTION_TYPE.UPDATE_FORM_SUBMITTED_STATUS: {
            return { ...state, isSubmittedForm: action.isSubmitted };
        }
        case ADMIN_ACTION_TYPE.INVALID_WARRANTY_ENTRY: {
            return { ...state, warrantyExistStatus: action.payload };
        }
        case GLOBAL_ACTION_TYPE.UPDATE_DELETE_POPUP: {
            if (action.payload.dataInfo && !action.payload.dataInfo.contractorId) {
                return { ...state, tempContractorSelection: undefined };
            } else {
                return { ...state };
            }
        }

        default:
            return state;
    }
};

export default reducer;
